import { InjectionToken, Provider } from '@angular/core';
import {
  CLIENT_LIST_FILTERS,
  PROJECT_LIST_CONTEXT,
  PROJECT_LIST_FILTERS,
} from '@icilalune/list-feature/tokens';
import { ROUTED_PAGE } from './route.providers';
import {
  distinctUntilChanged,
  filter,
  map,
  Observable,
  shareReplay,
} from 'rxjs';
import {
  BusinessUnits,
  contextApps,
  contextMotionDesign,
  Page,
} from '@nx-icilalune/data/icilalune/types';
import {
  TERMS_BUSINESS_UNIT,
  TERMS_DOMAIN,
  TERMS_TECHNOLOGY,
  TERMS_TYPE,
} from '@nx-icilalune/data/icilalune/tokens';
import { DrupalTerm } from '@nx-icilalune/drupal-types';
import { getProjectFilters } from './project.providers';

export const IS_PAGE_LIST_CONTEXT = new InjectionToken<boolean>(
  'IS_PAGE_LIST_CONTEXT'
);

export const LIST_PROVIDERS: Provider[] = [
  {
    provide: PROJECT_LIST_CONTEXT,
    deps: [ROUTED_PAGE],
    useFactory: (routedPage$: Observable<Page>) => {
      return routedPage$.pipe(
        map((page) => {
          return page.template;
        }),
        distinctUntilChanged(),
        map((template) => {
          if (template === 'list:apps') {
            return contextApps;
          } else if (template === 'list:motion-design') {
            return contextMotionDesign;
          }
          return undefined;
        }),
        shareReplay(1)
      );
    },
  },
  {
    provide: PROJECT_LIST_FILTERS,
    deps: [
      PROJECT_LIST_CONTEXT,
      TERMS_TYPE,
      TERMS_DOMAIN,
      TERMS_BUSINESS_UNIT,
      TERMS_TECHNOLOGY,
    ],
    useFactory: (
      projectBusinessUnit$: Observable<BusinessUnits>,
      typeTerms$: Observable<DrupalTerm[]>,
      domainTerms$: Observable<DrupalTerm[]>
    ) =>
      getProjectFilters(projectBusinessUnit$, typeTerms$, domainTerms$, true),
  },
  {
    provide: CLIENT_LIST_FILTERS,
    deps: [TERMS_DOMAIN],
    useFactory: (domainTerms$: Observable<DrupalTerm[]>) =>
      domainTerms$.pipe(
        filter((domainTerms) => !!domainTerms),
        map((domainTerms) => {
          return [
            {
              label: 'Domaines',
              filters: domainTerms,
              id: 'domains',
            },
          ];
        })
      ),
  },
];
